import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import { keymap, pathmap } from 'lcc-state';
import css from '../css/topicgroup.m.css';
const factory = create({ theme }).properties();
export const FlashCardsButton = factory(({ properties, middleware: { theme } }) => {
    const themeCss = theme.classes(css);
    const { topicid, text } = properties();
    const icon = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#flashcard`;
    return v('div', {
        classes: [themeCss.action],
        xqa: 'flashcard-action-button',
        tabIndex: 0,
        onclick: (event) => {
            event && event.stopPropagation();
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/flashcards`);
            view();
        },
        onkeydown: (event) => {
            const { path } = keymap.get(topicid);
            const { view } = pathmap.get(`${path}/flashcards`);
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    view();
            }
        }
    }, [
        v('svg', { classes: [themeCss.actionIcon], 'xmlns:xlink': 'http://www.w3.org/1999/xlink' }, [
            v('use', {
                href: icon,
                'xlink:href': icon
            })
        ]),
        v('div', { classes: [themeCss.actionText] }, [text])
    ]);
});
